<template>
    <div class="internalHeader cell">
        <h1><img src="../assets/bookYourRide.svg" alt="Book Your Ride"></h1>
    </div>
</template>
